import HeroBgAnimation from '../HeroBgAnimation'
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, TextLoopLabel, Title, TitleName, Span, SubTitle, ResumeButton } from './HeroStyle'
import HeroImg from '../../images/HeroImage.png'
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import ScrollReveal from '../ScrollReveal';

const HeroSection = () => {
    return (
        <div id="about">
            <HeroContainer>
                <HeroBg>
                    <HeroBgAnimation />
                </HeroBg>
                <HeroInnerContainer >
                    <HeroLeftContainer id="Left">
                        <ScrollReveal direction="up" index={0} stagger={150}>
                            <Title>
                                Hi, I am <TitleName>{Bio.name}</TitleName>
                            </Title>
                        </ScrollReveal>
                        <ScrollReveal direction="up" index={1} stagger={150}>
                            <TextLoop>
                                <TextLoopLabel>I am a</TextLoopLabel>
                                <Span>
                                    <Typewriter
                                        options={{
                                            strings: Bio.roles,
                                            autoStart: true,
                                            loop: true,
                                        }}
                                    />
                                </Span>
                            </TextLoop>
                        </ScrollReveal>
                        <ScrollReveal direction="up" index={2} stagger={150}>
                            <SubTitle>{Bio.description}</SubTitle>
                        </ScrollReveal>
                        <ScrollReveal direction="up" index={3} stagger={150}>
                            <ResumeButton href={Bio.resume} target='display'>Check Resume</ResumeButton>
                        </ScrollReveal>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <ScrollReveal direction="down" index={1} stagger={150}>
                            <Img src={HeroImg} alt="hero-image" />
                        </ScrollReveal>
                    </HeroRightContainer>
                </HeroInnerContainer>
            </HeroContainer>
        </div>
    )
}

export default HeroSection